const $doc = $(document);
const $win = $(window);

function hideElementOnDocumentClick(event, clickHandler) {
	var $target = $(event.target);
	var $wrapper = $('.wrapper');
	var $html = $('html, body');

	var elementClass = clickHandler.elementClass;
	var triggerClass = clickHandler.triggerClass;
	var elementVisibleClass = clickHandler.elementVisibleClass;
	var triggerActiveClass = clickHandler.triggerActiveClass;
	var globalVisibleClass = clickHandler.globalVisibleClass;

	if (
		!$target.hasClass(elementClass) &&
		!$target.parents('.' + elementClass).length &&
		!$target.hasClass(triggerClass) &&
		!$target.parents('.' + triggerClass).length
	) {
		$('.' + elementClass).removeClass(elementVisibleClass);
		$('.' + triggerClass).removeClass(triggerActiveClass);

		$wrapper.removeClass(globalVisibleClass);
		$html.removeClass(globalVisibleClass);
	}
}

/**
 * @param  {String} elementClass             Selector for the element to hide
 * @param  {String} triggerClass             Selector for the trigger
 * @param  {String} elementVisibleClass      Classname to remove from the element
 * @param  {String} triggerActiveClass       Classname to remove from the trigger
 * @param  {String} globalVisibleClass       Classname to remove from the `html` tag
 */
var clickHandlers = [
	{
		elementClass: 'popup',
		triggerClass: 'link-popup',
		elementVisibleClass: 'is-open',
		triggerActiveClass: '',
		globalVisibleClass: 'overlay no-scroll'
	}
];

var canvasSig = document.getElementById("signature-pad");
var signaturePad = null;

$doc
	.on('click', '.link-popup', function(e) {
		e.preventDefault();

		$(this.hash).addClass('is-open');
		$(this.hash).find('input[type="radio"]').iCheck({
			radioClass: 'iradio_flat-blue'
		});

		$('body').addClass('no-scroll overlay');

		if($(this.hash).find('canvas').length > 0) {
			var w = $('.signature-pad-wrapper').width();
	    canvasSig.width = w;
	    canvasSig.height = 146;
			signaturePad = new SignaturePad(canvasSig, {
				backgroundColor: "rgb(235,245,251)",
				onBegin: function(e) {
					$('.complete_sig').prop('disabled', false);
				}
			});
			signaturePad.off();
		}
	})
	.on('ifChanged', 'input[name="field-signature-method"]', function(e) {
		if($(this).prop('checked')) {
			let _val = $(this).val();
			switch(_val) {
				case 'type':
					$('#field-signature-string').prop('disabled', false).val('');
					signaturePad.off();
					break;
				case 'draw':
					$('#field-signature-string').val('').prop('disabled', true);
					signaturePad.on();
					break;
			}

			signaturePad.clear();
			$('.complete_sig').prop('disabled', true);
		}
	})
	.on('input', 'input#field-signature-string', function(e) {
		let _val = $(this).val();
		if(_val == "") {
			signaturePad.clear();
			$('.complete_sig').prop('disabled', true);
		} else {
			$('.complete_sig').prop('disabled', false);

			signaturePad.clear();

			var ctx = canvasSig.getContext("2d");
			ctx.font = "60px journal";
			ctx.textAlign = "center";

			var w = $('.signature-pad-wrapper').width();
			ctx.fillText(_val, w/2, 80);
		}
	})
	.on('click', '.clear_sig', function(e) {
		signaturePad.clear();
		$('.complete_sig').prop('disabled', true);
	})
	.on('click', '.complete_sig', function(e) {
		let _val = $('input[name="field-signature-method"]:checked').val();
		if (_val == 'type') {
		  var dataURL = canvasSig.toDataURL('image/png');
		} else {
		  var dataURL = signaturePad.toDataURL('image/png');
		}
		console.log(dataURL);
	})
	.on('click', '.popup__close', function(e) {
		e.preventDefault();

		$(this)
			.closest('.popup')
			.removeClass('is-open');
		$('body').removeClass('no-scroll overlay');
	})
	.on('click touchend', function(event) {
		if ($('.popup.is-open').length) {
			clickHandlers.forEach(function(clickHandler) {
				hideElementOnDocumentClick(event, clickHandler);
			});
		}
	});


// WEBPACK FOOTER //
// ../assets/js/popup.js